import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkupLastVoices from '../markup/vote_last_voices.js';
import pointsMarkupTopVoicesAvg from '../markup/vote_top_voices_avg.js';
import pointsMarkupTopVoicesCount from '../markup/vote_top_voices_count.js';

import toolsMarkup from '../markup/tools.js';



const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const menuBt = document.querySelector('#MenuResultsOfVotes');

const onSuccessPointsLoad = (loadedPoints) => {
  console.log(loadedPoints);
  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {

    if (loadedPoints.data && loadedPoints.data.last_voices) {
      document.querySelector('#fest-vote-result-body').style.display = 'block';
      document.querySelector('#fest-vote-result-helper').style.display = 'none';

      document.querySelector('#vote_result_card_count_value').innerHTML = loadedPoints.data.count_voices;
      document.querySelector('#vote_result_card_avt_value').innerHTML = loadedPoints.data.total_all_voices;
      document.querySelector('#vote_result_card_more_activity').innerHTML = loadedPoints.data.count_max_voices_from_super_activity_user;
      pointsMarkupLastVoices.drawDataInContainer(loadedPoints.data.last_voices);
      pointsMarkupTopVoicesCount.drawDataInContainer(loadedPoints.data.top_count_voices);
      pointsMarkupTopVoicesAvg.drawDataInContainer(loadedPoints.data.top_avg_voice);
    } else {

      document.querySelector('#fest-vote-result-body').style.display = 'none';
      document.querySelector('#fest-vote-result-helper').style.display = 'block';
    }

  }
  //   console.log(loadedPoints);
  //   pointsMarkup.drawDataInContainer(loadedPoints.data);
  // } else {
  //   pointsMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);
  // }/
};


const getBlue = () => {

  // pointsMarkup.cleanContainer();
  // pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);
  xhr.request = {
    metod: 'GET',
    url: 'votesResult',
    data: ``,
    callbackSuccess: onSuccessPointsLoad
  };
};

export default {

  start() {
    // getBlue();
      menuBt.addEventListener('click', getBlue);
  },

  redraw: getBlue,

  stop() {
    // pointsMarkup.cleanContainer();
     menuBt.removeEventListener('click', getBlue);
  }
};
